(function () {
  "use strict";

  // Reload the cart page the moment PluralCart's "Save Cart" modal is closed,
  // so the cart view reflects anything that changed while it was open.
  var path = location.pathname.replace(/\/+$/, "");
  if (path !== "/cart") return;

  // The modal overlay carries these classes and gets `open` added while visible.
  // PluralCart re-creates the node on each open (random id suffix), so we watch
  // a stable ancestor for both class changes and node add/remove.
  var OVERLAY_SELECTOR = ".aasaved-cart-dropdown-overlay.open";

  var reloaded = false;
  var wasOpen = false;
  var scheduled = false;

  function isOpen(el) {
    if (!el || !el.isConnected) return false;
    if (el.classList.contains("open")) return true;
    if (el.hasAttribute("hidden")) return false;
    var style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return false;
    return el.getClientRects().length > 0;
  }

  function check() {
    if (reloaded) return;

    var overlay = document.querySelector(OVERLAY_SELECTOR);
    if (isOpen(overlay)) {
      wasOpen = true;
      return;
    }

    // Modal was open on an earlier check and is now closed (or removed).
    if (wasOpen) {
      reloaded = true;
      try { observer.disconnect(); } catch (e) {}
      window.location.reload();
    }
  }

  function schedule() {
    if (scheduled || reloaded) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      check();
    });
  }

  var observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["class", "style", "hidden"]
  });

  // Safety nets for close paths (Escape key, overlay/backdrop click).
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") schedule();
  });

  check();
})();
